import { object, string } from 'yup';

export const validationSchema = object({
  emailOrNumber: string()
    .required()
    .matches(
      /^((([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,})))|(^\(?([0-9]{3})\)?[-.]?([0-9]{3})[-.]?([0-9]{4}))$/,
    ),
});
